import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { compatAPI } from '../../utils/api';

export default function CompatDevicesPage() {
    const [devices, setDevices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        compatAPI.getDevices()
            .then(res => {
                const d = res.data;
                const raw = Array.isArray(d) ? d
                          : Array.isArray(d?.devices) ? d.devices
                          : Array.isArray(d?.rows) ? d.rows
                          : Array.isArray(d?.data) ? d.data
                          : [];
                // compat_devices columns: device_id, slug, display_name, brand,
                // category, oui_prefixes (JSON array), total_sessions, ...
                // The page renders Device / Manufacturer / Type / Protocol / Sessions,
                // so map the backend names onto the page's older naming.
                const rows = raw.map(r => ({
                    id:            r.id ?? r.device_id,
                    name:          r.display_name || r.name || r.slug || '-',
                    manufacturer:  r.brand || r.manufacturer || '-',
                    type:          r.category || r.type || '-',
                    protocol:      r.protocol || (Array.isArray(r.oui_prefixes) ? r.oui_prefixes.join(', ') : '-'),
                    session_count: r.total_sessions ?? r.session_count ?? 0,
                }));
                setDevices(rows);
            })
            .catch(err => console.error('Devices error:', err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="text-gray-400">Loading...</div>;

    return (
        <div>
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-900">Device Database</h2>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Device</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Manufacturer</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Protocol</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sessions</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {devices.map((device) => (
                                <tr key={device.id} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{device.name || device.model || '-'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{device.manufacturer || '-'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{device.type || '-'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{device.protocol || '-'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{device.session_count || 0}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                                        <Link to={`/admin/compat/devices/${device.id}`} className="text-zebcast-purple hover:underline">
                                            Edit
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                            {devices.length === 0 && (
                                <tr><td colSpan="6" className="px-6 py-6 text-sm text-gray-400 text-center">No devices in database</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
